import pasgpsLogo from '@/assets/logo/pasgps.png';
import meptrackLogo from '@/assets/logo/meptrack.png';
import crystalLogo from '@/assets/logo/crystal.svg';

type BrandKey = 'pasgps' | 'meptrack' | 'crystal';

const BRAND_DEFAULTS: Record<BrandKey, { name: string; logo: string }> = {
  pasgps: { name: 'webgps', logo: pasgpsLogo },
  meptrack: { name: 'Meptrack', logo: meptrackLogo },
  crystal: { name: 'Crystal', logo: crystalLogo },
};

function brandKey(): BrandKey {
  const raw = String(import.meta.env.VITE_BRAND_KEY ?? '').trim().toLowerCase();
  if (raw === 'meptrack' || raw === 'crystal' || raw === 'pasgps') return raw;
  return 'pasgps';
}

export const appBrand = (() => {
  const key = brandKey();
  const fallback = BRAND_DEFAULTS[key];
  return {
    key,
    name: String(import.meta.env.VITE_BRAND_NAME ?? '').trim() || fallback.name,
    logo: String(import.meta.env.VITE_BRAND_LOGO_URL ?? '').trim() || fallback.logo,
  };
})();
